import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { SharingDataService } from 'src/app/Services/sharing-data.service';
import { GipUserRegisterForm, GiUserRegisterModel } from 'src/app/workflow/user/gipUserReg/gipUserReg.model';
import { UserService } from '../../user.service';
import { CommonService } from 'src/app/Services/common.service';
import { TranslateResourceDefinitionPipe } from 'src/app/shared/pipes/translateResourceDefinition.pipe';
import { ErrorHandlingService } from 'src/app/Services/errorHandling.service';
import { DownloadService } from 'src/app/workflow/download/download.service';
import { TranslateTextPipe } from 'src/app/shared/pipes/translateText.pipe';

@Component({
  selector: 'app-gip-user-register-form',
  templateUrl: './gipUserRegisterForm.component.html',
  styleUrls: ['./gipUserRegisterForm.component.css']
})
export class GipUserRegisterFormComponent implements OnInit {

  constructor(private shareData: SharingDataService,
    private userService: UserService,
    private commonService: CommonService,
    private translateResourceDefinition: TranslateResourceDefinitionPipe,
    private errorHandlingService: ErrorHandlingService,
    private downloadService: DownloadService,
    private translateText: TranslateTextPipe,
  ) { }

  @Input() public selectedTab: number;
  @Output() public submit = new EventEmitter();
  @Output() public moveToLogin = new EventEmitter();

  resourceDefinition;

  modelInput = GipUserRegisterForm;
  siteKey: string;
  recaptcharesponse = "";
  gipDefault;
  Language;
  enabledRecaptcha: boolean;
  groupName= "REGISTER";

  formular = [
    { formControlName: 'SALUTION', hidden: false, required: true, picklist: 'V_MS_SALUTATION_VL_T' },
    { formControlName: 'NAME', hidden: false, newRow: true, required: true, inputString: true },
    { formControlName: 'SURNAME', hidden: false, newRow: true, required: true, inputString: true },
    { formControlName: 'TITLE', hidden: false, newRow: true, required: false, picklist: 'V_MS_TITLE_VL_T', canEmptyValue: true },
    { formControlName: 'LOGIN', hidden: false, newRow: true, required: true, inputString: true },
    { formControlName: 'EMAIL', hidden: false, newRow: true, required: true, inputString: true },
    { formControlName: 'PHONE', hidden: false, newRow: true, required: true, inputString: true },
    // { formControlName: 'AcceptTermOfUse', hidden: false, required: true, checkbox: true },
  ];

  action(action) {
    this[action]();
  }

  ngOnInit(): void {
    this.shareData.currentResourceDefinition.subscribe(data => this.resourceDefinition = data);
    this.shareData.currentGipDefault.subscribe(data => this.gipDefault = data);
    this.shareData.currentLanguage.subscribe(data => this.Language = data);

    this.getCustomLogin();
  }

  ngOnChanges(changes: SimpleChanges){
    if(changes.selectedTab.currentValue == 1){
      this.enabledRecaptcha = this.translateText.transform("RECAPTCHAENABLED", this.gipDefault, "GIP_NAME", "GIP_VALUE") == "true" ? true : false;
      if(this.enabledRecaptcha){
        this.getSiteKey();
      }
    }
  }

  isRegisterEnabled() {
    return this.modelInput.value.AcceptTermOfUse && this.modelInput.value.ReadDataProtection && this.modelInput.status == "VALID" && (!this.enabledRecaptcha || (this.recaptcharesponse != null && this.recaptcharesponse != ""));
  }

  getCustomLogin() {
    this.formular.forEach(formularElement => {
      if (formularElement.formControlName == "LOGIN") {
        var enableDefaultLogin = this.translateText.transform("CUSTOMLOGIN", this.gipDefault, "GIP_NAME", "GIP_VALUE") == "true" ? true : false;
        if(enableDefaultLogin){
          formularElement.hidden = false;
        } else {
          formularElement.hidden = true;
          this.modelInput.controls.LOGIN.setValue("0");
        }
      }
    });
  }

  getAcceptTermOfUse(){
    var text = this.translateResourceDefinition.transform('AcceptTermOfUse', this.resourceDefinition, 'KEY_NAME', 'LONG_TEXT', "Common");
    var placeholder = this.translateResourceDefinition.transform('LinkTerms', this.resourceDefinition, 'KEY_NAME', 'LONG_TEXT', "Common");
    text = text.replace('{0}', `<p class="linka">&nbsp;${placeholder}&nbsp;</p>`)
    return text;
  }

  getReadDataProtection(){
    var text = this.translateResourceDefinition.transform('ReadDataProtection', this.resourceDefinition, 'KEY_NAME', 'LONG_TEXT', "Common");
    var placeholder = this.translateResourceDefinition.transform('SID_DataProtection', this.resourceDefinition, 'KEY_NAME', 'LONG_TEXT', "Common");
    text = text.replace('{0}', `<p class="linkr">&nbsp;${placeholder}&nbsp;</p>`)
    return text;
  }

  getSiteKey() {
    this.siteKey = this.translateText.transform("RECAPTCHASITEKEY", this.gipDefault, "GIP_NAME", "GIP_VALUE")
    this.loadScript('https://www.google.com/recaptcha/api.js');
  }

  loadScript(url) {
    var script = document.createElement('script')
    script.type = 'text/javascript';

    script.src = url;
    document.getElementsByTagName('head')[0].appendChild(script);
  }

  resolved(event) {
    this.recaptcharesponse = event;
  }

  download(event) {
    if(event.srcElement.className == "linka"){
      this.downloadService.downloadFileDSNB(this.commonService.getGipServicesUrl() + 'file/TermsOfUseFile', undefined, (response) => {
        this.errorHandlingService.showError(this.translateResourceDefinition.transform('ServiceFileDoesntExist', this.resourceDefinition, 'KEY_NAME', 'LONG_TEXT', "Common"), undefined)
      });
    }
    if(event.srcElement.className == "linkr"){
      this.downloadService.downloadFileDSNB(this.commonService.getGipServicesUrl() + 'file/DataProtectionFile', undefined, (response) => {
        this.errorHandlingService.showError(this.translateResourceDefinition.transform('ServiceFileDoesntExist', this.resourceDefinition, 'KEY_NAME', 'LONG_TEXT', "Common"), undefined)
      });
    }
  }

  register() {
    console.log(this.modelInput)

    let model = new GiUserRegisterModel();
    model.fromFormGroupModel(this.modelInput);

    this.userService.postData(`portal/register?recaptcharesponse=${this.recaptcharesponse}&lang=${this.Language}`, model, (data) => {
      console.log(data)
      this.errorHandlingService.showSuccess(this.translateResourceDefinition.transform('KV_CR', this.resourceDefinition, 'KEY_NAME', "LONG_TEXT", "Common"), undefined);
      this.modelInput.disable();
      this.moveToLogin.emit();
    },
      (response: Response) => {
        if (response.status >= 400 && response.status < 500)
          this.errorHandlingService.showError(this.translateResourceDefinition.transform('KV_ERR', this.resourceDefinition, 'KEY_NAME', "LONG_TEXT", "Common"), undefined);
        else {
          this.errorHandlingService.showError(this.translateResourceDefinition.transform('PortalTechnicalFail', this.resourceDefinition, 'KEY_NAME', "LONG_TEXT", "Common"), undefined);
        }
      }
    );
  }
}
